export const STORAGE_PREFIX = 'liberty_report_filter_'

export const API_LOGS_SESSION_KEY = 'apilogs_filter' as const
export const DEFAULT_PAYMENT_LOGS_SESSION_KEY = 'defaultpaymentlogs_filter' as const
export const FINANCIAL_DAILY_SESSION_KEY = 'financialdailylogs_filter' as const
export const FINANCIAL_DAILY_DEFAULTS_SESSION_KEY = 'defaultfinancialdailylogs_filter' as const
export const IMPERSONATE_LOGS_SESSION_KEY = 'impersonates_logs_filter' as const
export const MESSAGE_LOGS_SESSION_KEY = 'messagelogs_filter' as const
export const MRG_REPORT_SESSION_KEY = 'residentclaims_filter' as const
export const OUTSTANDING_BALANCE_SESSION_KEY = 'outstandingreport_filter' as const
export const PAYMENT_LOGS_SESSION_KEY = 'paymentlogs_filter' as const
export const PMC_PERFORMANCE_SESSION_KEY = 'pmcperformancereport_filter' as const
export const WEEKLY_REIMBURSEMENTS_SESSION_KEY = 'financialmrglogs_filter' as const
